import React from "react";

export const SelectionCheckbox = ({ isSelected, onChange }) => {
  return (
    <>
      <input type="checkbox" style={{ display: "none" }} />
      <label className="checkbox checkbox-single">
        <input type="checkbox" checked={isSelected} onChange={onChange} />
        <span />
      </label>
    </>
  );
}

const groupingItemOnSelect = (props) => {
  const { ids, setIds, customerId, nonSelectableIds } = props;
  if (ids.some((id) => id === customerId)) {
    setIds(ids.filter((id) => id !== customerId && !nonSelectableIds.includes(id)));
  } else {
    const newIds = [...ids];
    if (!nonSelectableIds.includes(customerId))
      newIds.push(customerId);
    setIds(newIds);
  }
}

const groupingAllOnSelect = (props) => {
  const { isSelected, setIds, entities, nonSelectableIds } = props;
  if (!isSelected) {
    const allIds = [];
    entities.forEach((el) => !nonSelectableIds.includes(el.id) && allIds.push(el.id));
    setIds(allIds);
  } else {
    setIds([]);
  }

  return isSelected;
}

// check official documentations: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Row%20Selection&selectedStory=Custom%20Selection%20Column%20Header%20Style&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
export const getSelectRow = (props) => {

  const { entities, ids, setIds, hideSelected, nonSelectableIds = [] } = props;
  return {
    mode: "checkbox",
    nonSelectable: nonSelectableIds,
    nonSelectableClasses: 'table-danger',
    // classes: 'table-danger',
    clickToSelect: true,
    hideSelectAll: false,
    hideSelectColumn: hideSelected,
    selectionHeaderRenderer: () => {
      const isSelected =
        entities && entities.length > 0 && entities.length === ids.length;

      const props = { isSelected, entities, setIds, nonSelectableIds };
      return (
        <SelectionCheckbox
          isSelected={isSelected}
          onChange={() => groupingAllOnSelect(props)}
        />
      );
    },
    selectionRenderer: ({ rowIndex }) => {
      const isSelected = ids.some((el) => el === entities[rowIndex].id)
      const props = { ids, setIds, customerId: entities[rowIndex].id, nonSelectableIds };
      return (
        <SelectionCheckbox
          isSelected={isSelected}
          onChange={() => groupingItemOnSelect(props)}
        />
      );
    },
    // onSelect: (row, isSelect, rowIndex, e) => {
    //   console.log(row.id);
    //   console.log(isSelect);
    //   console.log(rowIndex);
    //   console.log(e);
    // },
    // onSelectAll: (isSelect, rows, e) => {
    //   console.log(isSelect);
    //   console.log(rows);
    //   console.log(e);
    // }
    // selectColumnStyle: ({ checked,
    //   disabled,
    //   rowIndex,
    //   rowKey }) => {

    //   return { backgroundColor: 'blue' };
    // },
  };
}



export const getEditableSelectRow = (props) => {

  const { entities, ids, setIds, hideSelected, nonSelectableIds = [] } = props;
  return {
    mode: "checkbox",
    nonSelectable: nonSelectableIds,
    nonSelectableClasses: 'table-danger',
    // classes: 'table-danger',
    clickToSelect: false,
    hideSelectAll: false,
    hideSelectColumn: hideSelected,
    selectionHeaderRenderer: () => {
      const isSelected =
        entities && entities.length > 0 && entities.length === ids.length;

      const props = { isSelected, entities, setIds, nonSelectableIds };
      return (
        <SelectionCheckbox
          isSelected={isSelected}
          onChange={() => groupingEditableAllOnSelect(props)}
        />
      );
    },
    selectionRenderer: ({ rowIndex }) => {
      const isSelected = ids.some((el) => el === entities[rowIndex].id)
      const props = { ids, setIds, customerId: entities[rowIndex].id, nonSelectableIds };
      return (
        <SelectionCheckbox
          isSelected={isSelected}
          onChange={() => groupingEditableItemOnSelect(props)}
        />
      );
    },
  };
}

const groupingEditableItemOnSelect = (props) => {
  const { ids, setIds, customerId, nonSelectableIds } = props;
  if (ids.some((id) => id === customerId)) {
    setIds(ids.filter((id) => id !== customerId && !nonSelectableIds.includes(id)));
  } else {
    const newIds = [...ids];
    if (!nonSelectableIds.includes(customerId))
      newIds.push(customerId);
    setIds(newIds);
  }
}

const groupingEditableAllOnSelect = (props) => {
  const { isSelected, setIds, entities, nonSelectableIds } = props;
  if (!isSelected) {
    const allIds = [];
    entities.forEach((el) => !nonSelectableIds.includes(el.id) && allIds.push(el.id));
    setIds(allIds);
  } else {
    setIds([]);
  }

  return isSelected;
}

// check official documentations: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Row%20Selection&selectedStory=Custom%20Selection%20Column%20Header%20Style&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
export const getSelectRowMultiSelectCheckBoxList = (props) => {

  const { entities, ids, setIds, hideSelected, nonSelectableIds = [] } = props;
  return {
    mode: "checkbox",
    bgColor: '#5ac444',
    nonSelectable: nonSelectableIds,
    nonSelectableClasses: 'table-danger',
    // classes: 'table-danger',
    clickToSelect: true,
    hideSelectAll: false,
    hideSelectColumn: false,
    selectionHeaderRenderer: () => {
      const isSelected =
        entities && entities.length > 0 && entities.length === ids.length;

      const props = { isSelected, entities, setIds, nonSelectableIds };
      return (
        <SelectionCheckbox
          isSelected={isSelected}
          onChange={() => groupingAllOnSelect(props)}
        />
      );
    },
    selectionRenderer: ({ rowIndex }) => {
      const isSelected = ids.some((el) => el === entities[rowIndex].id)
      const props = { ids, setIds, customerId: entities[rowIndex].id, nonSelectableIds };
      return (
        <SelectionCheckbox
          isSelected={isSelected}
          onChange={() => groupingItemOnSelect(props)}
        />
      );
    },
    // onSelect: (row, isSelect, rowIndex, e) => {
    //   console.log(row.id);
    //   console.log(isSelect);
    //   console.log(rowIndex);
    //   console.log(e);
    // },
    // onSelectAll: (isSelect, rows, e) => {
    //   console.log(isSelect);
    //   console.log(rows);
    //   console.log(e);
    // }
    // selectColumnStyle: ({ checked,
    //   disabled,
    //   rowIndex,
    //   rowKey }) => {

    //   return { backgroundColor: 'blue' };
    // },
  };
}
